import { createClient } from "@supabase/supabase-js";

/**
 * 🌐 iVivaCore Frontend Supabase Client
 * Implementation: Enforces presence of environment variables to prevent placeholder fallback in production.
 */
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const VITE_SUPABASE_KEY =
  import.meta.env.VITE_SUPABASE_KEY ||
  import.meta.env.VITE_SUPABASE_Publishable_KEY;

if (
  !SUPABASE_URL ||
  !VITE_SUPABASE_KEY ||
  SUPABASE_URL.includes("placeholder")
) {
  console.error("🚨 [CLIENT-DB] CRITICAL CONFIGURATION MISSING");
  console.warn("The application will fail to authenticate or sync data.");
}

// In production, we should avoid falling back to broken strings
const finalUrl = SUPABASE_URL || "https://MISSING_CONFIG.supabase.co";
const finalKey = VITE_SUPABASE_KEY || "MISSING_KEY";

export default createClient(finalUrl, finalKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});
